/*jshint esversion: 9 */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from 'react-router-dom';
// import { Navigate } from 'react-router-dom';
// import { useNavigate } from "react-router-dom";

import Input from "../../components/UI/Input/Input";
import Button from "../../components/UI/Button/Button";
import Spinner from "../../components/UI/Spinner/Spinner";
import classes from "./Auth.css";
import * as actions from "../../store/actions/index";
import { doLog, updateObject, checkValidity } from "../../shared/utility";

class Auth extends Component {
  state = {
    isSignup: false,
    controls: {
      user: {
        elementType: "input",
        elementConfig: {
          // type: 'email',
          // placeholder: 'Email Address'
          type: "text",
          placeholder: "User code",
        },
        value: "",
        validation: {
          required: true,
          // isEmail: true
          isEmail: false,
        },
        valid: false,
        touched: false,
      },
      password: {
        elementType: "input",
        elementConfig: {
          type: "password",
          placeholder: "Password",
        },
        value: "",
        validation: {
          required: true,
          minLength: 4,
          // required: false,
          // minLength: 0
        },
        valid: false,
        touched: false,
      },
    },
  };

  constructor(props) {
    super(props);
    this.userCodeInput = React.createRef();
  }

  componentDidMount() {
    if (doLog()) console.log(
      "[Auth].componentDidMount authRedirectPath:",
      this.props.authRedirectPath
    );
    if (this.props.authRedirectPath !== "/admin") {
      //Nothing is in process, so just redirect back to the start of the process
      this.props.onSetAuthRedirectPath("/admin");
    }
    if (doLog()) console.log("[Auth].componentDidMount: userCodeInput:", this.userCodeInput);
    if (this.userCodeInput.current !== null) {
      this.userCodeInput.current.focus();
    }
  }

  componentDidUpdate() {
    if (doLog()) console.log(
      "[Auth].componentDidUpdate authRedirectPath:",
      this.props.authRedirectPath
    );
    if (this.props.authRedirectPath !== "/admin") {
      //Nothing is in process, so just redirect back to the start of the process
      //   this.props.onSetAuthRedirectPath("/admin");
    //   useNavigate(this.props.authRedirectPath);
    }
  }

  inputChangedHandler = (event, controlName) => {
    const updatedControls = updateObject(this.state.controls, {
      [controlName]: updateObject(this.state.controls[controlName], {
        value: event.target.value,
        valid: checkValidity(
          event.target.value,
          this.state.controls[controlName].validation
        ),
        touched: true,
      }),
    });
    this.setState({ controls: updatedControls });
  };

  submitHandler = (event) => {
    if (doLog()) console.log("[Auth].submitHandler");
    event.preventDefault();
    this.props.onAuth(
      this.state.controls.user.value,
      this.state.controls.password.value
    );
  };

  render() {
    if (doLog()) console.log("[Auth].render");
    if (doLog()) console.log("[Auth].render props:", this.props);
    const formElementsArray = [];
    for (let key in this.state.controls) {
      if (doLog()) console.log("[Auth].render key:", key);
      formElementsArray.push({
        id: key,
        config: this.state.controls[key],
      });
    }

    let form = formElementsArray.map((formElement) => (
      <Input
        key={formElement.id}
        elementType={formElement.config.elementType}
        elementConfig={formElement.config.elementConfig}
        value={formElement.config.value}
        invalid={!formElement.config.valid}
        shouldValidate={formElement.config.validation}
        touched={formElement.config.touched}
        changed={(event) => this.inputChangedHandler(event, formElement.id)}
        ref={formElement.id === 'user' ? this.userCodeInput : null}
      />
    ));

    if (this.props.loading) {
      form = <Spinner />;
    }

    if (this.props.isAuthenticated) {
      form = <Redirect to={this.props.authRedirectPath} />
      // form = <Navigate to={this.props.authRedirectPath} />
    }

    let errorMessage = null;
    if (this.props.error) {
      errorMessage = <p>{this.props.error.message}</p>;
    }

    //if (doLog()) console.log('[Auth].form:' + form);
    return (
      <div>
        <div className={classes.Auth}>
          {errorMessage}
          <form onSubmit={this.submitHandler}>
            <p>Please Log In</p>
            {form}
            <Button btnType="Success">SUBMIT</Button>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  if (doLog()) console.log("[Auth].mapStateToProps state.auth:", state.auth);
  return {
    loading: state.auth.loading,
    error: state.auth.error,
    isAuthenticated: state.auth.token !== null,
    authRedirectPath: state.auth.authRedirectPath,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAuth: (user, password) => dispatch(actions.auth(user, password)),
    onSetAuthRedirectPath: (path) =>
      dispatch(actions.setAuthRedirectPath(path)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Auth);
